import AppPage from "layouts/AppPage";
import { useParams, useSearchParams } from "react-router";
import { useCheckpointTemplateDetailQuery } from "features/Resources/CheckpointTemplate/hooks";
import CheckpointTemplateForm from "features/Resources/CheckpointTemplate/Layout/CheckpointTemplateForm";
import { useMemo } from "react";
import CaminoBreadcrumbs from "components/Breadcrumbs";
import { PEOPLE_TEAM_ROUTES } from "definitions/constants/routeConstants";
import { truncateEnd } from "helpers/string";

export default function CheckpointTemplatePage() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const { data, isLoading } = useCheckpointTemplateDetailQuery(id, {
    enabled: !!id && id !== "new",
  });
  const pathId = searchParams.get("pathId") ?? undefined;

  const formData = useMemo(() => {
    if (id === "new" && pathId) {
      return { paths: [{ id: pathId }] };
    }
    return data || {};
  }, [id, pathId, data]);

  if (!id) {
    return <AppPage>Template not found</AppPage>;
  }

  if (isLoading) {
    return <AppPage>Loading...</AppPage>;
  }

  return (
    <AppPage>
      <CaminoBreadcrumbs
        breadcrumbInfos={[
          { name: "Checkpoint Templates", toUrl: PEOPLE_TEAM_ROUTES.checkpointTemplates.index },
          { name: id === "new" ? "New" : `${truncateEnd(data?.name)}` },
        ]}
      />
      {(data || id === "new") && <CheckpointTemplateForm id={id} data={formData} />}
    </AppPage>
  );
}
